import { minBy, get, isEmpty } from "lodash";
import { findingUtil } from "@stormwater-software/common";

export const getFindingLabel = finding => {
  const d =
    Array.isArray(finding.commentables) && !isEmpty(finding.commentables)
    ? get(minBy(finding.commentables, "created_at"), "note.content")
    : finding.location;

  return `#${finding.number} - ${d}`;
};

export default findingUtil;
